"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports["default"] = void 0;
exports.get = get;
exports.getAll = getAll;
exports.getByPosition = getByPosition;
exports.getMultiple = getMultiple;
exports.getPositions = getPositions;
exports.getTeamInfo = getTeamInfo;
exports.search = search;
exports.typeaheadSearch = typeaheadSearch;
exports.update = update;
exports.updateEmployee = updateEmployee;
exports.updatePosition = updatePosition;
exports.updateProfile = updateProfile;
exports.updateSettings = updateSettings;

var _api = _interopRequireWildcard(require("./api"));

var _join = _interopRequireDefault(require("lodash/join"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var base = '/api/employee';

function get(id) {
  return _api["default"].get("".concat(base, "/").concat(id)).then(_api.extractData)["catch"](_api.errorHandler);
}

function create(employeeData) {
  return _api["default"].post(base, employeeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(employeeId, employeeData) {
  return _api["default"].put("".concat(base, "/").concat(employeeId), employeeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateProfile(employeeData) {
  return _api["default"].put("".concat(base, "/profile"), employeeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateSettings(employeeId, settings) {
  return _api["default"].put("".concat(base, "/settings"), settings).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPositions(employeeId) {
  return _api["default"].get("".concat(base, "/").concat(employeeId, "/positions")).then(_api.extractData)["catch"](_api.errorHandler);
}

function updatePosition(positionData) {
  return _api["default"].put("".concat(base, "/position"), positionData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getByPosition(positions) {
  var query = (0, _join["default"])(positions, '&employeePosition=');
  return _api["default"].get("".concat(base, "/by-position?employeePosition=").concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeaheadSearch(positions, name) {
  var nameQuery = name ? "q=".concat(encodeURIComponent(name)) : '';
  var positionsQuery = positions.length ? "positions=".concat(positions.join('&positions=')) : '';
  return _api["default"].get("".concat(base, "/typeahead?").concat(positionsQuery, "&").concat(nameQuery)).then(_api.extractData).then(function (data) {
    return data.map(function (item) {
      return {
        id: item.id,
        fullName: item.name,
        email: item.email
      };
    });
  })["catch"](_api.errorHandler);
}

function search(query) {
  var queryParams = _queryString["default"].stringify(query);

  return _api["default"].get("".concat(base, "/search?").concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateEmployee(employeeData) {
  return _api["default"].put("".concat(base, "/").concat(employeeData.id), employeeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAll() {
  return _api["default"].get("".concat(base, "?select=true")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getMultiple(ids) {
  return _api["default"].post("".concat(base, "/multiple"), {
    ids: ids
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getTeamInfo(ids) {
  return _api["default"].post("".concat(base, "/team-info"), ids).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: get,
  create: create,
  update: update,
  updateSettings: updateSettings,
  getByPosition: getByPosition,
  typeaheadSearch: typeaheadSearch,
  search: search,
  updateEmployee: updateEmployee,
  getAll: getAll,
  getMultiple: getMultiple,
  getTeamInfo: getTeamInfo,
  getPositions: getPositions,
  updatePosition: updatePosition,
  updateProfile: updateProfile
};
var _default = api;
exports["default"] = _default;